module.exports = __webpack_public_path__ + "static/media/Mountainbike-kopen-advies.21602cf2.mp4";